module.exports = __webpack_public_path__ + "img/avatar4.e2e275fe.png";